/* eslint-disable function-paren-newline */

import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

import { baseUrl } from '@/data/appConfig'
import store from '@/store'
import Notfound from '@/views/404/CareshipNotfound.vue'
import HomeLinks from '@/views/main/CareshipHome.vue'

import bookingFunnelRoutes from './booking-funnel'
import bookingStatusRoutes from './booking-status'
import dashboardRoutes from './dashboard'
import emailVerificationRoutes from './email-verification'
import postcodeRegistrationRoutes from './postcode-registration'
import userRoutes from './user'
import EmailTracking from "@/views/emailTracking/CareshipEmailTracking.vue";
import CareboxCalculator from "@/views/carebox/CareboxCalculator.vue";

declare global {
  interface Window {
    dataLayer: Array<Object | string | number>
    _mfq: Array<Object | string | number>
  }
}

const logger = require('debug')('careship:router')

Vue.use(VueRouter)

type Layout = 'booking-funnel' | 'dashboard' | 'main' | 'wide'
type AppSection = 'customer-dashboard' | 'booking-funnel'

export interface RouteMeta {
  gtm: string
  translateKey: string
  layout?: Layout
  title?: string
  appSection?: AppSection
}

const mainRoutes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/anfrage',
    beforeEnter: to => {
      window.dataLayer.push({
        event: 'history-update',
        'page-name': 'landing redirect (/)',
        appPagePath: to.fullPath,
      })
    },
  },
  {
    path: '/carebox',
    name: 'carebox',
    component: CareboxCalculator,
    meta: {
      layout: 'main',
    },
  },
  {
    path: '/landing-page',
    beforeEnter() {location.href = 'https://www.careship.de/'}
  },
  {
    path: '/home-links',
    name: 'home-links',
    component: HomeLinks,
  },
  {
    path: '/not-found',
    name: 'not-found',
    component: Notfound,
    meta: {
      layout: 'main',
    },
  },
  {
    path: '/tracking',
    name: 'emailTracking',
    component: EmailTracking,
    props: route => ({
      uuid: route.query.uuid,
      city: route.query.city || ''
    })
  },
  {
    path: '*',
    component: Notfound,
    meta: {
      layout: 'main',
    },
  },
]

const allRoutes = mainRoutes.concat(
  bookingFunnelRoutes,
  userRoutes,
  dashboardRoutes,
  bookingStatusRoutes,
  postcodeRegistrationRoutes,
  emailVerificationRoutes,
)

const router = new VueRouter({
  mode: 'history',
  base: baseUrl,
  routes: allRoutes,

  // Scroll to the top of the page when the router has changed
  scrollBehavior(to, from, savedPosition) {
    // savedPosition is only available for popstate navigations.
    if (savedPosition) {
      return savedPosition
    }

    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  logger(
    'routing from %s (%s) to %s (%s)',
    from.name,
    from.fullPath,
    to.name,
    to.fullPath,
  )
  next()
})

router.afterEach(to => {
  if (to.meta.translateKey) {
    document.title = store.getters.translation(to.meta.translateKey)
  } else {
    document.title = to.meta.gtm || to.name
  }

  // Wait one second to be sure page is loaded at all
  setInterval(() => {
    // eslint-disable-next-line no-underscore-dangle
    window._mfq.push(['newPageView'])
  }, 1000)
})

export { allRoutes } // Enables unit testing of the routes
export default router
